"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-left: -1em !important;\n  margin-right: -1em !important;\n\n  .ui[class*='left icon'].input {\n    display: flex;\n  }\n\n  .ui[class*='left icon'].input > input {\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _default = function _default(props) {
  return _react.default.createElement(MainFiltersWrapper, {
    raised: true
  }, props.children);
};

exports.default = _default;
var MainFiltersWrapper = (0, _styledComponents.default)(_semanticUiReact.Segment)(_templateObject());

//# sourceMappingURL=MainFiltersWrapper.js.map